function mapGetOnePremierAccessGroupData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListPremierAccessGroupsData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

function mapGetListPremierAccessGroupsSpendingData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

function mapGetListPremierAccessGroupUsersSpendingData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export {
    mapGetOnePremierAccessGroupData,
    mapGetListPremierAccessGroupsData,
    mapGetListPremierAccessGroupsSpendingData,
    mapGetListPremierAccessGroupUsersSpendingData,
};
